module.exports = __webpack_public_path__ + "img/XingfengBao.de12989f.png";